import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { HttpRequest } from "@/core/common/http/http-request";
import { plainToInstance } from "class-transformer";
import { CollectiveAgreementHolidayDto } from "@/core/features/collective-agreement-holidays/collective-agreement-holiday.dto";

export class WorkHolidaysResource {
  constructor(private readonly apiHttpClient: ApiHttpClient) {}

  async listMineByYear(year: number): Promise<CollectiveAgreementHolidayDto[]> {
    const query = new URLSearchParams({ year: year.toString() }).toString();
    const result = await this.apiHttpClient.request<null, CollectiveAgreementHolidayDto[]>(
      HttpRequest.create({
        url: `/api/work-holidays/me`,
        method: "GET",
        auth: true,
        query,
      })
    );
    return plainToInstance(CollectiveAgreementHolidayDto, result);
  }

  async listUserByYear(userId: string, year: number): Promise<CollectiveAgreementHolidayDto[]> {
    const query = new URLSearchParams({ year: year.toString() }).toString();
    const result = await this.apiHttpClient.request<null, CollectiveAgreementHolidayDto[]>(
      HttpRequest.create({
        url: `/api/work-holidays/users/${userId}`,
        method: "GET",
        auth: true,
        query,
      })
    );
    return plainToInstance(CollectiveAgreementHolidayDto, result);
  }
}
